export const TriggerMode = {
  TriggerAutomatically: 0,
  TriggerWithConfirm: 1,
  TriggerManually: 2,
  TriggerCheckOutPageInOnlineOrderingApp: 3,
  TriggerFirstOrderInOnlineOrderingApp: 4
};

export const RunType = {
  TypeUndefined: 0, //Something Wrong????
  RunOnce: 1,
  RunMultiple: 2
};
export const OutcomeType = {
  OutcomeType_Default: 0,
  OutcomeType_Products: 1,
  OutcomeType_FromCategories: 2,
  OutcomeType_FromTags: 3,
  OutcomeType_Categories: 4,
  OutcomeType_Tags: 5
};
export const priceTriggerType = {
  wholeOrderDiscountPriceTriggers: 0,
  rollIntoMealPriceTriggers: 1,
  perItemDiscountPriceTriggers: 2
};
export const OutcomePriceType = {
  OutcomePriceType_FlatDiscount: 0,
  OutcomePriceType_PercentageDiscount: 1,
  OutcomePriceType_FixedPrice: 2,
  OutcomePriceType_FreeUpToValue: 3
};
